import { useEffect } from 'react'

declare const hbspt: any

// HubSpotフォーム生成
const useHubSpotGenerate = (regionData: string, portalIdData: string, formIdData: string, targetData: string) => {
  useEffect(() => {
    window.setTimeout(function () {
      hbspt.forms.create({
        region: regionData,
        portalId: portalIdData,
        formId: formIdData,
        target: targetData,
      })
    }, 100)
  }, [])
  return <></>
}

export default useHubSpotGenerate
